import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import useDebounce from '../../helper/useDebounce'
import useViewportParams from '../../helper/useViewportHeight'
import { sendAnalyticsEvents } from '../../analytics/common'
import { appendLink } from '../../helper/utils'
import { setName } from './familySlice'
import { selectUserName } from '../signup/signupSlice'
import { selectEventsData } from '../events/eventsSlice'
import { EVENTS } from '../../analytics/events'
import { fontSize, wh, tabletMinWidth } from '../../mixins'
import MainHeadline from '../../UI/MainHeadline'
import MainDescription from '../../UI/MainDescription'
import UIButton from '../../UI/UIButton'


const isArabic = navigator.language.startsWith('ar');
const textAlign = isArabic ? 'right' : 'left';

const NameWrapper = styled.div`
    @media screen and (max-width: ${tabletMinWidth}px) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: height 100ms;
        ${({focused,viewportParams}) => !(focused && viewportParams) && 'flex-grow: 1;'}
        ${({viewportParams}) => viewportParams}
    }
`;

const Input = styled.input`
    ${wh('100%', '56px')};
    border: 1px solid #DEE0E6;
    box-sizing: border-box;
    border-radius: 12px;
    background: #FFFFFF;
    padding: 15px;
    ${fontSize(16)};
    line-height: 26px;
    color: #323232;
    text-align: ${textAlign};
    
    &::placeholder {
        color: #494E57;
    }
    
    &:focus,
    &:active {
        outline: none;
        border-color: #F58A3C;
    }
`;

const NameScreen = ({ history }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const name = useSelector(selectUserName);
    const eventsData = useSelector(selectEventsData);
    const [value, setValue] = useState(name || '');
    const debouncedName = useDebounce(value, 200);
    const viewportParams = useViewportParams();
    const [focused,setFocused] = useState(false);

    useEffect(() => {
        appendLink('../assets/screens/real_time_location.png');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => debouncedName && dispatch(setName(debouncedName)));

    useEffect(() => sendAnalyticsEvents(EVENTS.onboardingEnterNameShown, eventsData), [eventsData]);

    const onChangeHandler = (evt) => {
        const {target: {value}} = evt;
        setValue(value.slice(0,35));
    };

    const onContinueClick = () => {
        sendAnalyticsEvents(EVENTS.onboardingEnterNameSubmitted, eventsData);
        history.push('/real-time-location')
    };

    const setFocusedWithDelay = set => setTimeout(() => setFocused(set),100);

    return (
        <NameWrapper focused={focused} viewportParams={viewportParams} >
            <div>
                <MainHeadline>{t('what_is_your_name')}</MainHeadline>
                <MainDescription customMargin={'0 0 32px 0'}>{t('enter_your_name')}</MainDescription>
                <Input type="text"
                       value={value}
                       onChange={onChangeHandler}
                       onFocus={() => setFocusedWithDelay(true)}
                       onBlur={() => setFocusedWithDelay(false)}
                       placeholder={t('name')}
                       id={'name-input'}
                />
            </div>
            <UIButton onClick={onContinueClick} disabled={!value} />
        </NameWrapper>
    )
};

export default NameScreen
